import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { Button, useId } from '@fluentui/react-components';
import { ArrowLeftRegular, ArrowSortDownRegular, ArrowSortUpRegular } from '@fluentui/react-icons';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { getCategorySelectorHeaderStyles, getButtonInItemStyles } from './styles/category-selector-style';

const ButtonInList = (props) => {
  const classes = useDefaultStyles(getButtonInItemStyles);

  return <Button appearance="transparent" {...props} className={classes.button} >{props.children}</Button>;
};

// the category could be 'xx/' or 'xx/yy/'
function getParentCategory(category) {
  const slashCount = (category.match(/\//g) || []).length;

  if (slashCount === 1 && category.endsWith('/')) {
    return '';
  } else if (slashCount === 2 && category.endsWith('/')) {
    const firstSlashIndex = category.indexOf('/');
    return category.substring(0, firstSlashIndex + 1);
  }
  return category;
}

const SortIcon = ({ direction }) => (direction === -1 ? <ArrowSortDownRegular /> : <ArrowSortUpRegular />);

SortIcon.propTypes = {
  direction: PropTypes.number.isRequired,
};

export const ListHeader = ({
  parentCategory, orderby, onChangeScope, onSortChange,
}) => {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getCategorySelectorHeaderStyles);
  const onBackClick = useCallback((e) => {
    e.stopPropagation();
    onChangeScope(getParentCategory(parentCategory));
  }, [onChangeScope, parentCategory]);

  const onCategorySort = useCallback((e) => {
    e.stopPropagation();
    onSortChange('CategoryName');
  }, [onSortChange]);

  const onCoverageSort = useCallback((e) => {
    e.stopPropagation();
    onSortChange('Coverage');
  }, [onSortChange]);

  const backId = useId('back');
  const nameId = useId('name');
  const coverageId = useId('coverage');
  return (
    <div className={classes.root}>
      <div className={classes.name}>
        { parentCategory &&
          <ButtonInList icon={<ArrowLeftRegular />} onClick={onBackClick} id={backId} />
        }
        <ButtonInList onClick={onCategorySort} id={nameId} icon={orderby.CategoryName && <SortIcon direction={orderby.CategoryName} />} >
          {i18n.getString(_TL_('Categories'))}
        </ButtonInList>
      </div>
      <div className={classes.coverage}>
        <ButtonInList onClick={onCoverageSort} id={coverageId} icon={orderby.Coverage && <SortIcon direction={orderby.Coverage} />} >
          {i18n.getString(_TL_('Website coverage'))}
        </ButtonInList>
      </div>
    </div>
  );
};

ListHeader.propTypes = {
  parentCategory: PropTypes.string.isRequired,
  onChangeScope: PropTypes.func.isRequired,
  onSortChange: PropTypes.func.isRequired,
  orderby: PropTypes.shape({
    CategoryName: PropTypes.number,
    Coverage: PropTypes.number,
  }).isRequired,
};
